import { createSlice } from '@reduxjs/toolkit'
import { AsyncData, DataStatus } from '@repo/ui/utils'

import {
  createReportTemplate,
  deleteReportTemplate,
  getReportTemplates,
  updateReportTemplate,
} from '@/store/report-templates/thunks'
import { ReportTemplate } from '@/store/report-templates/types'

interface State {
  reportTemplates: AsyncData<ReportTemplate[]>
}

const initialState: State = {
  reportTemplates: DataStatus.Uninitialized,
}

const slice = createSlice({
  name: 'report-templates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReportTemplates.fulfilled, (state, { payload: { reportTemplates } }) => {
      state.reportTemplates = reportTemplates
    })

    builder.addCase(
      deleteReportTemplate.fulfilled,
      (
        state,
        {
          meta: {
            arg: { reportTemplate },
          },
        },
      ) => {
        if (!DataStatus.isFulfilled(state.reportTemplates)) return

        const reportTemplates = state.reportTemplates
        const isFound = reportTemplates.findIndex((rt) => rt.id === reportTemplate.id)
        if (isFound === -1) return
        // Delete
        reportTemplates.splice(isFound, 1)
      },
    )

    builder.addCase(createReportTemplate.fulfilled, (state, { payload: { reportTemplate } }) => {
      if (!DataStatus.isFulfilled(state.reportTemplates)) return
      state.reportTemplates.push(reportTemplate)
    })
    builder.addCase(updateReportTemplate.fulfilled, (state, { payload: { reportTemplate } }) => {
      if (!DataStatus.isFulfilled(state.reportTemplates)) return
      const reportTemplates = state.reportTemplates
      const isFound = reportTemplates.findIndex((rt) => rt.id === reportTemplate.id)
      if (isFound === -1) return
      // Update
      reportTemplates[isFound] = reportTemplate
    })
  },
})

// export const {  } = slice.actions
export type { State as ReportTemplatesState }
export const reportTemplatesInitialState = initialState
export default slice.reducer
